<template>
  <div>
    <div class="container">
      <div class="row mt-5">
        <div class="col-sm-12 mx-auto mb-3">
          <h1 class="text-center text-primary">Log in</h1>
        </div>
        <div class="col-lg-9 mx-auto">
          <div class="row">
            <div class="col-lg-6 mx-auto">
              <div class="card mb-3">
                <div class="card-body">
                  <form>
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input type="email" class="form-control" id="email" v-model="email" placeholder="Email">
                    </div>
                    <div class="form-group">
                      <label for="password">Password</label>
                      <input type="password" class="form-control" id="password" v-model="password" placeholder="Password">
                    </div>
                    <button class="btn float-right" :class="'btn-dark'" @click.prevent="login(email, password)">Log in</button>
                  </form>
                </div>
              </div>
              <p>
                <router-link to="/forgot" class="btn btn-link">Forgot my password</router-link> <br>
                <router-link to="/signup" class="btn btn-link">Sign up</router-link> <br>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'login',
  created() {
    this.googleProvider = new window.firebase.auth.GoogleAuthProvider();
  },
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  methods: {
    isValidEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    goOffline(uid) {
      const userStatusDatabaseRef = window.firebase.database().ref(`/status/${uid}`);
      userStatusDatabaseRef.set(null);
    },
    afterLogin() {
      this.$router.push('/');
    },
    // loginWithGoogle() {
    //   window.firebase.auth()
    //     .signInWithPopup(this.googleProvider)
    //     .then(res => this.afterLogin(res))
    //     .catch(err => this.$toasted.show(err.message));
    // },
    login() {
      if (this.isValidEmail(this.email)) {
        const { uid } = this.getCurrentUser;
        this.goOffline(uid);
        window.firebase.auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(res => this.afterLogin(res))
          .catch(err => this.$toasted.show(err.message));
      }
    },
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
};
</script>
